module.exports = "/images/tutorial-calendar.gif?682f2612856659ef1584ff3013c4ced8";